import {FormIconButton} from '@hconnect/common/components/formFields'
import {spawnSuccessToast} from '@hm/fundamental'
import TuneIcon from '@mui/icons-material/Tune'
import React, {FC, useCallback, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../../../consts'

import {ApproversAdjustDialog} from './ApproversAdjustDialog'

type ApproversAdjustButtonProps = {
  plantId: string
}

export const ApproversAdjustButton: FC<ApproversAdjustButtonProps> = ({plantId}) => {
  const {t} = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)
  const [isOpen, setIsOpen] = useState(false)

  const handleClose = useCallback(
    ({isSuccess = false} = {}) => {
      setIsOpen(false)
      if (isSuccess) {
        spawnSuccessToast(t('approversAdjust.label.updateSuccess'))
      }
    },
    [t]
  )

  return (
    <>
      <FormIconButton data-test-id="approver-adjust-button" onClick={() => setIsOpen(true)}>
        <TuneIcon />
      </FormIconButton>
      {isOpen && <ApproversAdjustDialog plantId={plantId} handleClose={handleClose} />}
    </>
  )
}
